import { EmptyReviews } from "~/components/EmptyReviews/EmptyReviews";
import { ProductInfoSource } from "~/components/StoreInfo/types";
import { Review } from "../../components/Review/Review";
import { useLogicReviews } from "../../reviews.hook";
import { ReviewsProps, SortType } from "../../reviews.types";
import styles from "./reviews-skin-1.module.css";

export const ReviewsSkin1 = ({ reviews, source, name }: ReviewsProps) => {
  const { t, reviewsState, sortType, handleSort } = useLogicReviews({
    reviews,
    source,
    name
  });

  return (
    <div className={styles.reviewsSkin1}>
      {reviews.length > 0 ?
      <>
          <div className={styles.content}>
            {reviewsState?.map((review, index) =>
          <div
            className={styles.reviewBox}
            key={`${index}-${review.stars}-${review.scoreDate}`}>

                <Review review={review} />
              </div>
          )}
          </div>
          {source === ProductInfoSource.ProductPage &&
        <div className={styles.controls} role={"review-controls"}>
              <input
            type='radio'
            id='desc'
            checked={sortType === SortType.DESC} />

              <label
            onClick={() => {
              handleSort(SortType.DESC);
            }}
            htmlFor='desc'>

                {t("reviews.recent_reviews")}
              </label>
              <input
            type='radio'
            id='asc'
            checked={sortType === SortType.ASC} />

              <label
            onClick={() => {
              handleSort(SortType.ASC);
            }}
            htmlFor='asc'>

                {t("reviews.older_reviews")}
              </label>
            </div>}

        </> :

      <EmptyReviews source={source} name={name} />}

    </div>);

};